import transport from "core/model/api/transport";

export default {
  get(auctionid: number): Promise<any> {
    return transport.get({
      options: {
        routeName: "auctioneerDebug",
      },
      route: `/potentialreceivers/${auctionid}`,
    });
  },
};
